jQuery(function ($) {
    $('.slick-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: false,
        responsive: [
            {breakpoint: 1024, settings: {slidesToShow: 2}},
            {breakpoint: 970, settings: 'unslick'}
        ],
        prevArrow: $('.slick-slider-btn--prev'),
        nextArrow: $('.slick-slider-btn--next'),
    });
});
